import * as React from "react";
import { useTypewriter } from "@/hooks/use-typewriter";
import { Info } from "lucide-react";

interface Props {
  thinking?: string;
  setIsThinkingComplete: (isThinkingComplete: boolean) => void;
  showThinkingType: boolean;
}

export const SnapshotCollectionsOutcomesSearchThinking: React.FC<Props> = ({
  showThinkingType,
  thinking,
  setIsThinkingComplete,
}) => {
  const typedContend = useTypewriter(thinking ? thinking : "", 15);

  const displayValue = showThinkingType ? typedContend : thinking;
  React.useEffect(() => {
    if (!!thinking && thinking === displayValue) {
      setIsThinkingComplete(true);
    }
  }, [displayValue, thinking, setIsThinkingComplete]);

  return (
    <div className="mb-4 flex flex-1 rounded border border-gray-200 p-4 shadow-sm">
      {!!thinking && thinking === displayValue ? (
        <div className="h-5 w-5">
          <Info />
        </div>
      ) : (
        <div className="h-5 w-5 animate-spin rounded-full border-b-2 border-gray-900"></div>
      )}
      <span className="ml-4 text-sm text-gray-700">{thinking ? displayValue : "Thinking..."}</span>
    </div>
  );
};
